import React from 'react';
import { Box, TextField, Stack, IconButton } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';

export interface SearchBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onClear: () => void;
  placeholder?: string;
}

/**
 * Search bar component for worklist grids
 */
export const SearchBar: React.FC<SearchBarProps> = ({
  searchTerm,
  onSearchChange,
  onClear,
  placeholder = 'Search by patient, account, refund ID, status...',
}) => (
  <Box sx={{ mb: 3 }}>
    <Stack direction="row" spacing={1} alignItems="center">
      <SearchIcon sx={{ color: '#64748b' }} />
      <TextField
        fullWidth
        size="small"
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSearchChange(e.target.value)}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#ffffff',
            '& fieldset': {
              borderColor: '#e2e8f0',
            },
            '&:hover fieldset': {
              borderColor: '#3b82f6',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#3b82f6',
            },
          },
        }}
      />
      {searchTerm && (
        <IconButton size="small" onClick={onClear} sx={{ color: '#64748b' }}>
          <ClearIcon fontSize="small" />
        </IconButton>
      )}
    </Stack>
  </Box>
);

export default SearchBar;
